import { FC } from 'react';

import { motion } from 'framer-motion';

import StyledSwitch from 'components/StyledSwitch';

import { useTranslation } from 'react-i18next';
import styles from './JoblioZoomToggle.module.scss';

interface JoblioZoomToggleProps {
  onChange: (isCustom: boolean) => void;
  isLoading: boolean;
}

const JoblioZoomToggle: FC<JoblioZoomToggleProps> = ({
  onChange,
  isLoading
}) => {
  const { t } = useTranslation()

  return (
    <motion.div layout className={styles.interviewLinkContainer}>
      <motion.div layout className={styles.interviewLinkTitle}>
        {t('common.joblioZoom')}
      </motion.div>
      <StyledSwitch noLabels onChange={onChange} disabled={isLoading} />
    </motion.div>
  );
};

export default JoblioZoomToggle;
